import { Component, OnInit } from '@angular/core';

import { AccountingDashboardService } from '../../../services/accounting/accounting-dashboard.service';
import { AlertService } from '../../../services/common/alert.service';

@Component({
  selector: 'app-accounting-dashboard',
  templateUrl: './accounting-dashboard.component.html',
  styleUrls: ['./accounting-dashboard.component.css'],
})
export class AccountingDashboardComponent implements OnInit {
  loading: boolean = true;
  data: any = null;
  error: string = '';

  constructor(
    private accountingDashboardService: AccountingDashboardService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.loadDashboard();
  }

  loadDashboard(): void {
    this.loading = true;
    this.accountingDashboardService
      .getDashboard()
      .then((response) => {
        this.data = response;
        this.loading = false;
        if (response.has_inconsistencies) {
          this.alertService.alert_status_warning('Accounting data is inconsistent!');
        }
      })
      .catch((error) => {
        this.error = 'Failed to load accounting data';
        this.loading = false;
        this.alertService.alert_status_danger('Failed to load accounting data');
      });
  }

  formatMoney(amount: number): string {
    if (amount === null || amount === undefined) return '$0.00';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  }
}
